import React from 'react'
import cx from 'classnames'

import Image from '@/image.js'

class Slideshow extends React.Component {
  constructor () {
    super()
    this.state = {
      active: 0
    }
    this.slideshow = React.createRef()
  }
  componentDidMount () {
    const Flickity = require('flickity')
    const slideshow = this.slideshow.current
    const flky = new Flickity(slideshow, {
      contain: true,
      wrapAround: true,
      pageDots: false,
      cellAlign: 'center',
      prevNextButtons: false
    })
    this.setState({
      flky: flky
    })
    flky.on('select', index => this.setState({ active: index }))
  }
  render () {
    const {
      images
    } = this.props
    return (
      <div className='x y rel'>
        <div ref={this.slideshow} className='x y'>
          {images && images.map(image => (
            <div className='x' key={image._key}>
              <Image className='x' imageId={image.imageId} key={image._key} />
            </div>
          ))}
        </div>
        <div className='abs bottom left p1 f jcs aic'>
          {images && images.map((im, i) => (
            <div
              key={i}
              className={cx('brand__slideshow-nums mr1 f jcc aic cw', {
                'active': this.state.active === i
              })}
              onClick={() => this.state.flky.select(i)}><span>{i + 1}</span></div>
          ))}
        </div>
      </div>
    )
  }
}

export default Slideshow
